import { Pagination } from "@mui/material";
import { BackpackIcon, Cross2Icon } from "@radix-ui/react-icons";
import { MoreHorizontal, Search } from "lucide-react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { NavLink } from "react-router-dom";
import {
  ACTIVER_DESACTIVER_PRESTATAIRE,
  DELETE_PLANING,
  LIST_PLANING,
  LISTE_COMMUNE_SANS_PAGINATION,
  LISTE_PRESTATAIRE,
} from "../../Utils/constant";
import { Loader } from "../../components/Widget/Loader";
import { UpdateTeam } from "../../components/utilisateur/UpdateTeam";
import { deleteOne, disable, find } from "../../services/service";
import { useGlobalStore } from "../../store/store";
import { useStoreApp } from "../../store/storeApp";
import { AddPrestataire } from "./AddPrestataire";

export const Prestataire = () => {
  const planing = useGlobalStore();
  const [item, setItem] = useState(null);
  const [param, setParam] = useState({
    prestataireId: "",
    communeId: "",
    equipeId: "",
  });
  const [active, setActive] = useState({
    index: 0,
    value: "Gestion d'equipe",
    label: "",
  });

  const prestataire = useStoreApp();
  const [communes, setCommunes] = useState([]);
  const [loadingCommunes, setLoadingCommunes] = useState(false);
  const [communeId, setCommuneId] = useState("");

  useEffect(() => {
    prestataire.getData(
      LISTE_PRESTATAIRE,
      { page: 0, param: "", size: 10 },
      `&communeId=${communeId}`
    );
  }, [communeId]);

  useEffect(() => {
    const loadCommunes = async () => {
      setLoadingCommunes(true);
      try {
        const res = await find(
          `${LISTE_COMMUNE_SANS_PAGINATION}?prestataireId=${param.prestataireId}`
        );
        const items = res?.data?.data ?? res?.data?.donnee ?? res?.data ?? [];
        setCommunes(items);
      } catch (err) {
        console.error(err);
        setCommunes([]);
      } finally {
        setLoadingCommunes(false);
      }
    };
    loadCommunes();
  }, []);

  const more = async (page) => {
    prestataire.getData(
      LISTE_PRESTATAIRE,
      { page: page - 1, param: "", size: 10 },
      ""
    );
  };

  return (
    <div className="">
      <dialog id="delete" className="modal">
        <div className="modal-box max-w-md rounded-lg">
          <h3 className="font-extrabold text-xl text-red-600 ">Attention</h3>
          <p className="pt-2 text-black font-medium">
            Voulez vous vraiment effectuer cette action ?
          </p>
          <div className="modal-action">
            <form
              method="dialog"
              className="w-full flex items-center justify-end gap-x-4"
            >
              <button
                id="close_delete"
                className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold"
              >
                Annuler
              </button>
              <button
                onClick={() => {
                  deleteOne(DELETE_PLANING, item?.publicId)
                    .then(() => {
                      document.getElementById("close").click();
                      document.getElementById("close_delete").click();
                      planing.getData(
                        `${LIST_PLANING}?equipeId=${param.equipeId}&communeId=${param.communeId}&prestataireId=${param.prestataireId}`
                      );
                      toast.success("Planing supprimé");
                    })
                    .catch((err) => {});
                }}
                className="bg-red-600 text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold"
              >
                Suppirmer
              </button>
            </form>
          </div>
        </div>
      </dialog>

      <dialog id="my_modal_3" className="modal">
        <div className="modal-box lg:w-96">
          <form method="dialog">
            <button
              id="close"
              className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
            >
              ✕
            </button>
          </form>
          <ul className="menu dropdown-content bg-base-100">
            {item?.extendedProps?.enabled ? (
              <li
                onClick={() => {
                  // document.getElementById('close').click()
                  document.getElementById("edit_planing").showModal();
                }}
              >
                <a>Modifier la planification</a>
              </li>
            ) : null}

            <li
              onClick={() => {
                document.getElementById("delete").showModal();
              }}
              className="hover:bg-red-100 hover:rounded hover:text-red-700 text-red-700 font-medium"
            >
              <a>Supprimer la planification</a>
            </li>
          </ul>
        </div>
      </dialog>
      <>
        <div className="mb-4 ">
          <h3 class="font-mtn text-3xl font-bold">Gestion de prestataire</h3>
          <p className="text-gray-500 text-sm">
            Liste des prestataires enregistrés dans le système
          </p>
        </div>

        <div className="flex items-center">
          <div className="relative flex-1 max-w-sm">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              onChange={(e) => {
                prestataire.getData(
                  LISTE_PRESTATAIRE,
                  { page: 0, param: e.target.value, size: 10 },
                  "&communeId=" + communeId
                );
              }}
              type="text"
              placeholder="Rechercher un element..."
              className="input input-bordered px-3 pl-10 pr-10 w-full max-w-sm h-11 text-sm text-gray-900 placeholder:text-gray-400"
            />
          </div>

          <select
            className="select select-bordered h-10 ml-2"
            onChange={(e) => {
              setCommuneId(e.target.value);
            }}
            disabled={loadingCommunes}
          >
            <option value={""}>
              {loadingCommunes ? "Chargement..." : "Choisir une commune"}
            </option>
            {communes?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.designation}
              </option>
            ))}
          </select>

          <button
            onClick={() => {
              setActive({
                index: 0,
                filter: "TECHNICIEN",
                value: "Equipes",
              });
              document.getElementById("add_prestataire").showModal();
            }}
            className="ml-auto btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white"
          >
            Ajouter un prestataire
          </button>
        </div>
        <dialog id="add_prestataire" className="modal rounded-none">
          <div className="modal-box w-10/12 max-w-xl h-3/5">
            <div className="modal-action">
              <h1 className="mr-auto text-2xl font-bold font-mtn">
                Ajouter un prestataire
              </h1>
              <form method="dialog">
                <button id="close_prestataire" className="btn btn-sm">
                  <Cross2Icon />
                </button>
              </form>
            </div>
            <AddPrestataire />
          </div>
        </dialog>
        <div className="grid md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-5 gap-2 my-8">
          {prestataire?.data?.data?.length === 0 ? (
            ""
          ) : prestataire?.data?.data?.length !== 0 && !prestataire?.loading ? (
            prestataire?.data?.data?.map((item) => (
              <div className="relative flex gap-1 items-center cursor-pointer text-black shadow border border-gray-100 bg-white rounded-md text-xs">
                <div className="dropdown dropdown-end absolute right-2 top-2">
                  <div
                    tabIndex={0}
                    role="button"
                    className="w-4 h-4 rounded-full flex items-center justify-center bg-gray-50"
                  >
                    <MoreHorizontal size={20} />
                  </div>
                  <ul
                    tabIndex={0}
                    className="mt-1 dropdown-content z-[1] menu p-2 border shadow bg-base-100 rounded-lg w-44"
                  >
                    <NavLink
                      to={`details/${item?.id}/${item?.designation}`}
                      className="px-3 text-xs bg-white hover:bg-gray-100 text-gray-600 h-9 w-full flex items-center justify-start rounded-lg"
                    >
                      Details
                    </NavLink>

                    <dialog
                      id={`update_Team${item?.equipe?.id}`}
                      className="modal rounded-none"
                    >
                      <div className="modal-box w-10/12 max-w-xl">
                        <div className="modal-action">
                          <h1 className="mr-auto text-2xl font-bold font-mtn">
                            Modification d'une equipe
                          </h1>
                          <form method="dialog">
                            <button id="close" className="btn btn-sm">
                              <Cross2Icon />
                            </button>
                          </form>
                        </div>
                        <UpdateTeam item={item} />
                      </div>
                    </dialog>

                    <div
                      onClick={() => {
                        disable(ACTIVER_DESACTIVER_PRESTATAIRE, item?.id).then(
                          (res) => {
                            if (res.status === 200) {
                              prestataire.getData(
                                LISTE_PRESTATAIRE,
                                { page: 0, param: "", size: 10 },
                                ""
                              );
                              toast.success("Operation effectuée");
                            }
                          }
                        );
                      }}
                      className="bg-white hover:bg-red-100 hover:text-red-600 text-xs h-9 w-full flex items-center justify-start rounded-lg px-3"
                    >
                      {item?.isActif ? "Desactiver" : "Activer"}
                    </div>
                  </ul>
                </div>
                <div className="bg-amber-100 w-10 h-10 rounded m-1 flex items-center justify-center">
                  <BackpackIcon />
                </div>
                <div className="">
                  <p className="text-sm truncate w-28">{item?.designation}</p>
                  <p
                    className={`w-fit px-2 border rounded-full ${
                      item?.isActif ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    {" "}
                    {item?.isActif ? "Actif" : "Inactif"}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <Loader />
          )}
        </div>
        {
          <div className="my-3 flex justify-end">
            {active ? (
              <Pagination
                onChange={(event, newValue) => more(newValue)}
                onSelect={(selectedPage) => more(selectedPage)}
                count={prestataire?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            ) : null}
          </div>
        }
      </>
    </div>
  );
};
